<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card color="white" elevation="0" style="border-radius: 20px !important">
      <v-card-title class="warning-color" style="border-radius: 20px !important">
        الادوية
        <v-spacer></v-spacer>

        <v-text-field rounded v-model="search" outlined append-icon="mdi-magnify" label="بحث" single-line hide-details></v-text-field>
        <div style="width: 20px"></div>
        <AddProduct @reloadTask="initialData()" />
      </v-card-title>
      <v-data-table :headers="headers" :items="ItemsFilter" :items-per-page="15" class="table-content table-warning-color">
        <template v-slot:[`item.productImage`]="{ item }">
          <v-avatar size="40">
            <img :src="`${$store.state.apiUrl}/${item.productImage}`" alt="" />
          </v-avatar>
        </template>

        <template v-slot:[`item.index`]="{ index }">
          <h4 style="padding: 0 3px">{{ index + 1 }}</h4>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <!-- <Images :images="item.images" style="display: inline-block" /> -->

          <v-btn icon @click="dialog = false">
            <DeleteProduct :dataToDelete="item" @reloadTask="initialData()" v-if="$store.state.userData.roleId == 1" />
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import AddProduct from "./product/AddProduct.vue";
import DeleteProduct from "./product/DeleteProduct.vue";
export default {
  components: {
    AddProduct,
    DeleteProduct,
  },
  data: () => ({
    overlay: false,
    search: "",
    products: [],
    headers: [
      { text: "التسلسل", value: "index" },
      { text: "صورة الدواء", value: "productImage" },
      { text: "اسم الدواء", value: "productName" },
      { text: "وصف الدواء", value: "productDescription" },
      { text: "الجرعة", value: "productDose" },
      { text: "سعر البيع", value: "sellPrice" },
      { text: "سعر الشراء", value: "buyPrice" },
      { text: "الاجراءات", value: "actions" },
    ],
  }),
  created() {
    this.initialData();
  },
  methods: {
    initialData() {
      let self = this;

      self.overlay = true;
      self.$http
        .get(`${self.$store.state.apiUrl}/products`, {
          headers: { Authorization: `Bearer ${self.$store.state.user}` },
        })
        .then((res) => {
          console.log(res.data);
          self.products = res.data;
          self.overlay = false;
        });
    },
  },
  computed: {
    ItemsFilter() {
      if (this.search) {
        return this.products.filter((item) => {
          return this.search
            .toLowerCase()
            .split(" ")
            .every((v) => item.sectionName.toLowerCase().includes(v));
        });
      } else {
        return this.products;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
